<template>
	<client-only>
		<div class="js-snz-widget p-16 tablet:p-0" :class="`js-snz-widget--${widgetKey.toLowerCase()}`" :data-hash="widgetHash">
			<div class="snz-spinner" />
		</div>
	</client-only>
</template>

<script>
export default {
	props: {
		widgetKey: {
			type: String,
			required: true,
		}
	},
	computed: {
		widgetHash() {
			return this.$config.thirdParty.snowReportWidgetHashByKey[this.widgetKey]
		}
	},
	mounted() {
		const script = document.createElement('script')
		script.id = 'snzwidget'
		script.type = 'text/javascript'
		script.async = true
		script.defer = true
		script.src = 'https://snowhq.com/widget-embeds/client/dist/widget.min.js'
		document.body.appendChild(script)
	},
	beforeDestroy() {
		const script = document.getElementById('snzwidget')
		if (script) script.remove()
	}
}
</script>

<style lang="scss">
body {
	-webkit-font-smoothing: auto !important;
	-moz-osx-font-smoothing: auto !important;
}
.snz-spinner {
	border-radius: 0.5rem;
	background-color: theme('colors.goGrayBrighter');
	animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
	&.snz-spinner--sm {
		width: 100%;
	}
	.js-snz-widget--all & {
		height: 1116px;
	}
	.js-snz-widget--chc & {
		height: 516px;
	}
	.js-snz-widget--zqn & {
		height: 616px;
	}
}
.snz-circle {
	display: none;
}
.snz-sml-container {
	padding: 0 !important;
	.snz-ski-area-table {
		padding: 0;
		.snz-table {
			max-width: none;
			.snz-left-title {
				text-align: left;
			}
			.snz-table-rows-large {
				min-width: auto !important;
			}
			.snz-table-rows:last-child .snz-icon {
				display: none;
			}
		}
		.snz-ski-area-table-bottom {
			flex-direction: column;
		}
	}
}
@media (max-width: theme('screens.tablet')) {
	.snz-table-rows-large {
		display: none;
	}
}
</style>
